module.exports = __webpack_public_path__ + "media/photo/AdobeStock_271134500_Edit_Wide@2x-0eb284f2.jpg";